<template>
    <flex-container direction="column" gap="xs">
        <text-heading>Welkom terug, {{ currentUser.name.firstName }} 👋</text-heading>
    </flex-container>
</template>

<script setup lang="ts">
    import useClient from '@/services/keyvue-api/composables/useClient';

    const { currentUser } = useClient();
</script>
